import Keypad from '@components/Keypad';
import { Button, Icon, Input, Stack } from '@servicetitan/design-system';
import classNames from 'classnames';
import styles from './CallControlKeypad.module.css';
import { useState } from 'react';
import SoftPhoneModule from '@modules/SoftPhoneModule';
import { useEventListener } from 'usehooks-ts';

interface CallControlKeypadProps {
  onClose: () => void;
  open: boolean;
}

export const VALID_KEYPAD_KEYS = '1234567890*#';

const CallControlKeypad = ({ onClose, open }: CallControlKeypadProps) => {
  const [dialedNumbers, setDialedNumbers] = useState('');
  const handleKeyboardEvent = (event: KeyboardEvent) => {
    if (open && VALID_KEYPAD_KEYS.includes(event.key)) {
      handleKeyPress(event.key);
    }
  };

  useEventListener('keydown', handleKeyboardEvent);

  const handleKeyPress = (key: string) => {
    setDialedNumbers((prevDialedNumbers) => prevDialedNumbers + key);
    SoftPhoneModule.dialer.dial(key);
  };

  return (
    <Stack direction='column' spacing={2}>
      <Stack spacing={1} justifyContent='space-between' alignItems='center'>
        <Input
          size='xsmall'
          width='100%'
          className={classNames('flex-grow-1', styles.callControlKeypadInput)}
          value={dialedNumbers}
          disabled
        />
        <Button
          aria-label='Close Keypad'
          size='small'
          fill='subtle'
          icon={<Icon name='close' size={16} />}
          onClick={onClose}
        />
      </Stack>
      <Keypad variant='callControl' onKeyClick={(key) => handleKeyPress(key)} />
    </Stack>
  );
};

export default CallControlKeypad;
